// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
/**
 * The Weave mapped Appointment status as a shiny new enum.
 */
export var Status_Enum;
(function (Status_Enum) {
    Status_Enum["UNKNOWN"] = "UNKNOWN";
    Status_Enum["UNCONFIRMED"] = "UNCONFIRMED";
    Status_Enum["ATTEMPTED"] = "ATTEMPTED";
    Status_Enum["CONFIRMED"] = "CONFIRMED";
    Status_Enum["IN_OFFICE"] = "IN_OFFICE";
    Status_Enum["COMPLETED"] = "COMPLETED";
    Status_Enum["CANCELED"] = "CANCELED";
    Status_Enum["NO_SHOW"] = "NO_SHOW";
})(Status_Enum || (Status_Enum = {}));
export var Status_Enum_index;
(function (Status_Enum_index) {
    Status_Enum_index[Status_Enum_index["UNKNOWN"] = 0] = "UNKNOWN";
    Status_Enum_index[Status_Enum_index["UNCONFIRMED"] = 1] = "UNCONFIRMED";
    Status_Enum_index[Status_Enum_index["ATTEMPTED"] = 2] = "ATTEMPTED";
    Status_Enum_index[Status_Enum_index["CONFIRMED"] = 3] = "CONFIRMED";
    Status_Enum_index[Status_Enum_index["IN_OFFICE"] = 4] = "IN_OFFICE";
    Status_Enum_index[Status_Enum_index["COMPLETED"] = 5] = "COMPLETED";
    Status_Enum_index[Status_Enum_index["CANCELED"] = 6] = "CANCELED";
    Status_Enum_index[Status_Enum_index["NO_SHOW"] = 7] = "NO_SHOW";
})(Status_Enum_index || (Status_Enum_index = {}));
